import axios from 'axios';

const apiCep = axios.create({
  baseURL: 'https://opencep.com/v1',
});

export default apiCep;
